import React, { useState } from "react";
import { CARD_STYLE } from "../../../../constants/styles";
import QuestionEditorCard from "./QuestionEditorCard";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../../constants/styles";

export default function EditQuestionnaireSectionModal({ open, section, onClose, onSave }) {

  const [sectionName, setSectionName] = useState(section?.name || "");
  const [questions, setQuestions] = useState([
    { id: 1, text: "We have enough desks for our teams", type: "scale", options: [] },
    { id: 2, text: "Our desks are set up with the correct IT", type: "scale", options: [] }
  ]);

  if (!open || !section) return null;

  const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  };

  const modalContainer = {
    ...CARD_STYLE,
    width: "700px",
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    padding: "0",
    overflow: "hidden",
	background:ADMIN_PANEL_BACKGROUND_COLOR
  };

  const headerStyle = {
    padding: "14px 20px",
    borderBottom: "1px solid #ddd",
    fontWeight: "600",
    fontSize: "14px",
    background:  GREY_GRADIENT_PANEL_BACKGROUND
  };

  const bodyStyle = {
    padding: "20px",
    overflowY: "auto",
    flex: 1
  };

  const footerStyle = {
    padding: "12px 20px",
    borderTop: "1px solid #ddd",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    background:  GREY_GRADIENT_PANEL_BACKGROUND
  };

  const inputStyle = {
    width: "calc(100% - 20px)",
    padding: "6px 8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "12px",
    marginBottom: "12px"
  };

  const buttonStyle = {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600"
  };

  const addQuestion = () => {
    setQuestions([...questions, ""]);
  };

  const updateQuestion = (index, value) => {
    const updated = [...questions];
    updated[index] = value;
    setQuestions(updated);
  };

  const removeQuestion = (index) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    onSave({
      ...section,
      name: sectionName,
      questions
    });
  };

  return (
    <div style={modalOverlay}>
      <div style={modalContainer}>

        {/* HEADER */}
        <div style={headerStyle}>
          Edit Section – {section.name}
        </div>

        {/* BODY */}
        <div style={bodyStyle}>
          <div style={{ fontSize: "12px", fontWeight: "600", marginBottom: "6px" }}>
            Section Name
          </div>
          <input
            style={inputStyle}
            value={sectionName}
            onChange={(e) => setSectionName(e.target.value)}
          />

          <div style={{ fontSize: "12px", fontWeight: "600", marginBottom: "6px", marginTop: "16px" }}>
            Questions
          </div>
		  {questions.map((q, i) => (
		    <QuestionEditorCard
		      key={q.id}
		      question={q}
		      index={i}
		      onMoveUp={() => {
		        if (i === 0) return;
		        const updated = [...questions];
		        [updated[i - 1], updated[i]] = [updated[i], updated[i - 1]];
		        setQuestions(updated);
		      }}
		      onMoveDown={() => {
		        if (i === questions.length - 1) return;
		        const updated = [...questions];
		        [updated[i + 1], updated[i]] = [updated[i], updated[i + 1]];
		        setQuestions(updated);
		      }}
		      onRemove={() => setQuestions(questions.filter((_, idx) => idx !== i))}
		      onSave={(updatedQ) => {
		        const updated = [...questions];
		        updated[i] = updatedQ;
		        setQuestions(updated);
		      }}
		    />
		  ))}



          <button style={{ ...buttonStyle, marginTop: "10px" }} onClick={addQuestion}>
            + Add Question
          </button>
        </div>

        {/* FOOTER */}
        <div style={footerStyle}>
          <button style={buttonStyle} onClick={onClose}>Cancel</button>
          <button style={buttonStyle} onClick={handleSave}>Save Section</button>
        </div>

      </div>
    </div>
  );
}
